export default  {
  path: 'addTax',
  component: () => import(/* webpackChunkName: "ad-position-list" */ '@/pages/addTax/index'),
  meta: {title:'增值税管理'}
}